/**
 * Generates a random number between two numbers
 * @ignore
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
export default function rnd(min, max) {
    return Math.floor((Math.random() * (max - min + 1)) + min);
}
